var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"items":_vm.items,"label":_vm.label,"item-text":"label","item-value":"rate_card_id","value":_vm.value},on:{"change":_vm.onChange}})
}
var staticRenderFns = []

export { render, staticRenderFns }